module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAKBAMAAABPkMOvAAAAJFBMVEUAAACampqampqZmZmZmZmWlpaZmZmZmZmioqKZmZmZmZmZmZk9x1jGAAAAC3RSTlMAB7uuqQm0wAvRm5OvwKwAAABHSURBVAjXY9BiAAFGSwZtBxBDbDND+xYBoIB1IgNrtSMDg/AmIC9oswCjtSJQmlXbUGRTAEih0GZvVYjW7O1AARAQyWBAAgAqKQskz3Bx7QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/to-b-icon.png
// module id = dGmO
// module chunks = 1